import React, { useState } from "react";
import { InputFieldComponent } from "components/form/input_field";
import { FormContentSection } from "components/form_content_section";
import { TwoColumnSection } from "components/two_column_section";
import { Col, Form, Row } from "react-bootstrap";
import { CustomButton } from "components/buttons/custom_button";
import { CustomTextButton } from "components/buttons/custom_text_button";
import { MapSection } from "components/map_section";
import { locationOutlineIcon } from "utils/data";
import { InputFileComponent } from "components/form/input_file_field";

export const ImportExportPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    file: null,
    location1: "",
    location2: "",
    location3: "",
    locationType: [
      { name: "encrypt", checked: false },
      { name: "geo-location", checked: false },
    ],
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleCheckboxChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: formData[e.target.name].map((item) => {
        if (item.name === e.target.value) {
          return {
            ...item,
            checked: e.target.checked,
          };
        }
        return item;
      }),
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };
  const handleReset = () => {
    setFormData({
      name: "",
      file: null,
      location1: "",
      location2: "",
      location3: "",
      locationType: [
        { name: "encrypt", checked: false },
        { name: "geo-location", checked: false },
      ],
    });
  };
  return (
    <TwoColumnSection
      firstColumn={
        <FormContentSection title="Please Fil the form">
          <Form
            className="d-flex flex-column gap-4"
            onSubmit={handleSubmit}
            onReset={handleReset}
          >
            <InputFileComponent
              id="upload-file"
              handleChange={(file) => {
                setFormData({
                  ...formData,
                  file: file,
                });
              }}
              className="bg-light"
            />
            <InputFieldComponent
              label="Name"
              placeholder="Type"
              className="bg-light"
              name="name"
              onChange={handleChange}
            />
            <div>
              <Form.Check
                inline
                type="checkbox"
                name="locationType"
                id="Encrypt"
                label="Encrypt"
                value="encrypt"
                onChange={handleCheckboxChange}
              />
              <Form.Check
                inline
                name="locationType"
                type="checkbox"
                id="geo-location"
                label="Geo Location"
                value="geo-location"
                onChange={handleCheckboxChange}
              />
            </div>
            <InputFieldComponent
              label="Field 1"
              placeholder="Geo location"
              className="bg-light"
              name="location1"
              sufixIcon={
                <img src={locationOutlineIcon} alt="Location Icon" width={20} />
              }
              onChange={handleChange}
            />
            <InputFieldComponent
              label="Field 2"
              placeholder="Lorem ipsum is dummy text"
              name="location2"
              className="bg-light"
              onChange={handleChange}
            />
            <InputFieldComponent
              label="Field 3"
              type="number"
              name="location3"
              placeholder="54846941616"
              className="bg-light"
              onChange={handleChange}
            />

            <Row className="align-items-center">
              <Col xs={7}>
                <CustomButton
                  className="btn-primary-gradient"
                  type="submit"
                  value="Show Results"
                />
              </Col>
              <Col xs={5}>
                <CustomTextButton value="Reset Map" type="reset" />
              </Col>
            </Row>
          </Form>
        </FormContentSection>
      }
      secondColumn={
        <MapSection
          mapCordiantes={[51.505, -0.09]}
          markerList={[
            {
              latitude: 51.505,
              longitude: -0.09,
              name: "Marker Name 1",
              fulladdress: "Address of the marker",
            },
          ]}
        />
      }
    />
  );
};
